import { useFirebaseToken } from '@/hooks/useFirebaseUser/useFirebaseToken'

import { useServiceGroupsServiceGetV1IndividualsByIndividualIdServiceGroups } from '../client/queries'

export const useServiceGroups = (individualId?: string) => {
  const token = useFirebaseToken()

  return useServiceGroupsServiceGetV1IndividualsByIndividualIdServiceGroups(
    { individualId: individualId! },
    undefined,
    {
      enabled: !!token && !!individualId,
    },
  )
}
